import { TableCell, TableRow } from '../../../components/table/CustomTable'
import React from 'react'
import { utcDateTimeToLocalString } from 'helpers/dateTimeHelper'
import { isoToLocaleFormat } from 'helpers/dateTimeHelper'
import CustomIcon from 'components/CustomIcon'
import { notificationType } from '../constants'

const NotificationReportItem = ({ item, selectedTab }) => {
  return (
    <TableRow>
      <TableCell>
        <div className="flex flex-col">
          <div className="font-bold mb-1 truncate">{item?.title}</div>
          <div className="text-2-clamp break-words">{item?.message}</div>
        </div>
      </TableCell>
      <TableCell className="w-36">
        <div className="flex items-center space-x-1 mb-2 text-sm leading-none">
          <CustomIcon icon="watch_later" size="sm" />{' '}
          <span>{utcDateTimeToLocalString(item.created_at, true, true)}</span>
        </div>
        <div className="flex items-center space-x-1 text-sm leading-none">
          <CustomIcon icon="calendar_today" size="sm" />
          <span>{isoToLocaleFormat(item?.created_at, true)}</span>
        </div>
      </TableCell>
      <TableCell className="w-36 whitespace-nowrap">
        {notificationType[2].value !== selectedTab.value &&
          <div className="mb-2 text-sm leading-none whitespace-nowrap">
            Total Users: {item?.receivers_count ?? 'N/A'}
          </div>
        }
        {notificationType[1].value !== selectedTab.value && (
          <div className="text-sm leading-none whitespace-nowrap">
            Active Users: {item?.devices_count ?? 'N/A'}
          </div>
        )}
      </TableCell>
      {notificationType[0].value === selectedTab.value && (
        <TableCell className="w-36 text-right">{item.no_of_clicks}</TableCell>
      )}
    </TableRow>
  )
}

export default NotificationReportItem
